export const APIParser = (response) => {
    if(!response.ok){
        //throw new Error(response.statusText);
        //return response.json();
        //console.log(response);
        return Promise.reject(response);
    }
    else{
        // extend the token by 14 days currently
        /*
        let cookies = new Cookies();

        cookies.set('triyo-token', cookies.get("triyo-token"), {expires: new Date(+new Date + 12096e5)});
        */

        // hey

        return response.json();
    }
}

export const AxiosAPIParser = (response) => {
    if(response.status !== 200){
        return Promise.reject(response.data);
    }
    else{
        return response.data;
    }
}

export const APIParserHtml = (response) => {
    if(!response.ok){
        return Promise.reject(response);
    }
    else{
        return response.text();
    }
}

export const APIParserNoMsg = (response) => {
    if (!response.ok){
        return {ok: response.ok, json: response.json()};
	}
    else{
        return response;
	}
}

export const APIDownloadFile = (response) => {
    if(!response.ok){
        // throw new Error(response.statusText);
        return Promise.reject(response);
    }
    else{
        return response.blob();
    }
}

export const APITimeout = (promise, time=6000) => {

    let timeout = new Promise((resolve, reject) => {
        let id = setTimeout(() => {
          clearTimeout(id);
          reject('Timed out in '+ time + 'ms.')
        }, time)
    })
    
    // Returns a race between our timeout and the passed in promise
    return Promise.race([
        promise,
        timeout
    ])
}